import { Controller } from '@hotwired/stimulus';

const REFRESH_INTERVAL_IN_MS = 1000;
const SECONDS_IN_HOUR = 3600;
const SECONDS_IN_MINUTE = 60;

export default class CountdownController extends Controller {
  static targets = ['countdown', 'expiration', 'remainingTime'];

  static values = {
    remainingSeconds: Number,
    remainingTimeTemplate: String,
  };

  connect() {
    this.startedAt = Date.now();
    this.timer = setInterval(this.refresh.bind(this), REFRESH_INTERVAL_IN_MS);
    this.refresh();
  }

  disconnect() {
    this.stop();
  }

  hide() {
    this.stop();
    this.element.classList.add('d-none');
  }

  refresh() {
    const elapsedInSeconds = Math.floor((Date.now() - this.startedAt) / 1000);
    const remainingSeconds = Math.max(
      this.remainingSecondsValue - elapsedInSeconds,
      0
    );

    this.remainingTimeTarget.textContent = this.formattedTime(remainingSeconds);

    if (remainingSeconds === 0) {
      this.stop();
      this.expire();
    }
  }

  expire() {
    this.countdownTarget.classList.add('d-none');
    this.expirationTarget.classList.remove('d-none');

    this.dispatch('delay-expired');
  }

  formattedTime(remainingSeconds) {
    const hours = Math.floor(remainingSeconds / SECONDS_IN_HOUR);
    const minutes = Math.floor(
      (remainingSeconds % SECONDS_IN_HOUR) / SECONDS_IN_MINUTE
    );

    return this.remainingTimeTemplateValue
      .replace('{hours}', hours)
      .replace('{minutes}', minutes);
  }

  stop() {
    if (!this.timer) return;

    clearInterval(this.timer);
    this.timer = null;
  }

  dispatch(eventName, detail = {}) {
    const event = new CustomEvent(`signature:${eventName}`, {
      bubbles: true,
      detail,
    });
    this.element.dispatchEvent(event);
  }
}
